module.exports = __webpack_public_path__ + "static/img/appStoreDownload.2928664.svg";